import { Component, Inject, OnInit, ViewChild, Input, ElementRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { GlobalSpinnerService } from '../../../../../shared/components/loader-service/global-spinner.service';
import { ReportsService } from '../../../services/reports.service';
import { ReportRequest } from '../../../domain/report/report-request.model';
import { ReportType } from '../../../domain/report/report-type.enum';
import { ReportDataSource } from '../../../domain/report/report-data-source.enum';
import { ReportGrouping } from '../../../domain/report/report-grouping.enum';
import { ReportDimension } from '../../../domain/report/report-dimension.enum';
import { ReportMetric } from '../../../domain/report/report-metric.enum';
import { MomentDateUtils } from '../../../../../shared/utils/moment-date-utils';
import { SortUtils } from '../../../../../shared/utils/sort-utils';

const Highcharts = require('highcharts/highcharts');

@Component({
  selector: 'cm-kn-main-table-metrics-chart-dialog',
  templateUrl: './kn-main-table-metrics-chart-dialog.component.html',
  styleUrls: ['./kn-main-table-metrics-chart-dialog.component.scss'],
  host: { 'class': 'kn-main-table-chart-pop-up' }
})
export class KnMainTableMetricsChartDialogComponent implements OnInit {
   @ViewChild('chart', {static: true}) chartEl: ElementRef;

  adUnitId: string;
  property: string;

  loading = false;

  constructor(public dialogRef: MatDialogRef<KnMainTableMetricsChartDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private gss: GlobalSpinnerService,
              private reportsService: ReportsService) {

      this.adUnitId = data.adUnitId;
      this.property = data.property;
  }


  ngOnInit(): void {
    this.getDailyReport();
  }

  renderChart(xAxisData, yAxisData) {
    const opts: any = {
      chart: {
        type: 'area',
        height: 140
      },
      title: {
        text: null //TODO Milos - Staviti metric ime (npr. Impressions)
      },
      legend: {
        enabled: false
      },
      tooltip: {
        pointFormat: '<b>{point.y}</b>'
      },
      xAxis: {
        categories: xAxisData
      },
      yAxis: {
        visible: false
      },
      series: [
        { data: yAxisData }
      ]
    };

    Highcharts.chart(this.chartEl.nativeElement, opts);
  }

  getDailyReport() {
    const reportRequest: ReportRequest = {
      reportGrouping: ReportGrouping.COMBINED,
      reportType: ReportType.FINANCIAL,
      dataSource: ReportDataSource.DATE_PERIOD_DEPENDENT,
      metrics: [
        ReportMetric.IMPRESSIONS,
        ReportMetric.REFRESH_RATE,
      ],
      dimensions: [
        ReportDimension.AD_UNIT,
        ReportDimension.DAY
      ],
      predicates: [
      ],
      filters: {
        dateFrom: MomentDateUtils.sevenDaysAgo(),
        dateTo: MomentDateUtils.today(),
        adUnitIds: [this.adUnitId]
      }
    };

    this.loading = true;
    this.gss.showLoader();
    this.reportsService.report(reportRequest).subscribe(res => {
      const xAxisData: string[] = [];
      const yAxisData: number[] = [];

      res.report.sort(SortUtils.propertyComparatorString('day')).forEach(element => {
        yAxisData.push(element[this.property]);
        xAxisData.push(element.day.split('-')[2]); // show only days on x axis
      });

      this.renderChart(xAxisData, yAxisData);
      this.gss.hideLoader();
      this.loading = false;
    }, error => {
      this.gss.hideLoader();
      this.loading = false;
    });
  }

  getHourlyReport() {
    this.loading = true;
    this.gss.showLoader();
    this.reportsService.getHourlyStats(this.adUnitId, MomentDateUtils.today(), MomentDateUtils.today()).subscribe(res => {
      const xAxisData: string[] = [];
      const yAxisData: number[] = [];

      res.hourly.sort(SortUtils.propertyComparatorString('time')).forEach(element => {
        yAxisData.push(element[this.property]);
        xAxisData.push(element.time.split(':')[0]); // show only hours on x axis
      });

      this.renderChart(xAxisData, yAxisData);
      this.gss.hideLoader();
      this.loading = false;
    }, error => {
      this.gss.hideLoader();
      this.loading = false;
    });
  }

  onChangeReportType(event: MatSlideToggleChange) {
    if (event.checked) {
      this.getHourlyReport();
    } else {
      this.getDailyReport();
    }
  }

}
